__turbopack_context__.v({
  "lineHeightLoose": "Text-module__R76Jfa__lineHeightLoose",
  "lineHeightNormal": "Text-module__R76Jfa__lineHeightNormal",
  "lineHeightRelaxed": "Text-module__R76Jfa__lineHeightRelaxed",
  "lineHeightSnug": "Text-module__R76Jfa__lineHeightSnug",
  "lineHeightTight": "Text-module__R76Jfa__lineHeightTight",
  "text": "Text-module__R76Jfa__text",
  "textL": "Text-module__R76Jfa__textL",
  "textM": "Text-module__R76Jfa__textM",
  "textS": "Text-module__R76Jfa__textS",
  "textXL": "Text-module__R76Jfa__textXL",
  "textXS": "Text-module__R76Jfa__textXS",
  "textXXL": "Text-module__R76Jfa__textXXL",
  "textXXS": "Text-module__R76Jfa__textXXS",
});
